var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('label',{class:[
        'irisv-radio-button',
        _vm.isLowEmphasis ? 'irisv-radio-button--low-emphasis font-caption' : 'font-body-1',
        _vm.isDisabled ? 'irisv-radio-button--disabled' : '',
    ]},[_c('input',{staticClass:"irisv-radio-button__input",attrs:{"type":"radio","name":_vm.name,"disabled":_vm.isDisabled},domProps:{"value":_vm.value,"checked":_vm.checkedBool},on:{"change":_vm.onChange}}),_c('span',{staticClass:"irisv-radio-button__styled-radio",attrs:{"aria-hidden":"true"}}),_c('span',{staticClass:"irisv-radio-button__label"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }